import React from "react";

export interface IconProps extends React.SVGAttributes<HTMLOrSVGElement> {
  size?: number;
}

export const IconCostIdleness: React.FC<IconProps> = ({
  size = 20,
  ...rest
}) => {
  return (
    <>
      <svg
        width={size}
        height={size}
        viewBox="0 0 24 29"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        {...rest}
      >
        <path
          d="M10 4h12v2c0 2-3 4-6 6-3-2-6-4-6-6V4zM10 28h12v-2c0-2-3-4-6-6-3 2-6 4-6 6v2z"
          stroke="#9E9E9E"
          strokeWidth="2"
          fill="#F5F5F5"
        />
        <line x1="10" y1="4" x2="10" y2="28" stroke="#9E9E9E" strokeWidth="2" />
        <line x1="22" y1="4" x2="22" y2="28" stroke="#9E9E9E" strokeWidth="2" />

        <text
          x="16"
          y="18"
          fontSize="20"
          fontWeight="bold"
          fill="#FF4D4F"
          textAnchor="middle"
          dominantBaseline="middle"
        >
          $
        </text>
      </svg>
    </>
  );
};
